import { isNumber } from "lodash-es";
import styled, { css } from "styled-components";
import { boxShadow100, boxShadow200 } from "../../../common/boxShadows";
import { cssBody200 } from "../../typography/styles";
const themes = {
    dark: css `
    padding: ${(p) => p.theme.spacing.sp8};
    background-color: ${(p) => p.theme.systemColors.grey800};
    color: ${(p) => p.theme.systemColors.white};
  `,
    light: css `
    padding: ${(p) => p.theme.spacing.sp16};
    background-color: ${(p) => p.theme.systemColors.white};
    color: ${(p) => p.theme.systemColors.grey600};

    border: solid 1px ${(p) => p.theme.systemColors.grey300};
    ${boxShadow100};
  `,
    grey: css `
    padding: ${(p) => p.theme.spacing.sp16};
    background-color: ${(p) => p.theme.systemColors.grey100};
    color: ${(p) => p.theme.systemColors.grey600};

    ${boxShadow200};
  `,
};
export const Content = styled.div `
  border-radius: 6px;

  max-width: ${(p) => (isNumber(p.$maxWidth) && p.$maxWidth > 0 ? p.$maxWidth + "px" : "auto")};
  transition: opacity 0.2s ease;

  ${cssBody200};

  ${(p) => themes[p.$colorType || "dark"]};

  ${(p) => p.$small && `padding: ${p.theme.spacing.sp8}`};
`;
